<template>
  <div class="lock">
    <div class="pin-info lock-input">
      <h1 class="page-title">
        {{
          correctPin.length > 0
            ? $t("pages.login.confirmPin")
            : $t("pages.login.createPin")
        }}
      </h1>
    </div>
    <div class="pin-display">
      <div class="confirmation-dots">
        <svg>
          <g>
            <circle class="pin-circle" cx="10" cy="10" r="8" />
            <circle class="pin-circle" cx="50" cy="10" r="8" />
            <circle class="pin-circle" cx="90" cy="10" r="8" />
            <circle class="pin-circle" cx="130" cy="10" r="8" />
          </g>
        </svg>
      </div>
      <div class="lock-input keypad">
        <div
          class="keypad--button cs0"
          v-for="num of [1, 2, 3, 4, 5, 6, 7, 8, 9]"
          :key="num"
          :data-value="num"
        >
          {{ num }}
        </div>
        <div class="keypad--button keyboard--button__back-arrow">
          <i class="fhr fhr-delete cs0"></i>
        </div>
        <div class="keypad--button cs0" data-value="0">0</div>
        <div class="keypad--button keyboard--button__x cs0">
          <div class="fhr fhr-trash"></div>
        </div>
      </div>
      <!-- <div id="biometricsButton" class="lock-input" @click="loginWithBiometrics">
        {{ $t("pages.login.useFaceId") }}
      </div> -->
      <div id="kidsModeButton" class="lock-input" onclick="ChildSelectorModal.open()">
        {{ $t("pages.kids.kidsMode") }}
      </div>
    </div>
    <v-style>.bouncefix{display: none;}</v-style>
  </div>
</template>

<script>
import * as CCDb from "../utilities/db";
import * as nativeLink from "../utilities/nativeLink";
export default {
  name: "LockScreen",
  data() {
    return {
      pinArray: [],
      disableInput: false,
      correctPin: "",
      // Every listener this component adds, so they can be taken off again
      // when it goes away. Left behind, the keypad keeps reacting to clicks
      // and key presses after the lock screen is gone.
      listeners: [],
    };
  },
  async mounted() {
    const profile = await CCDb.getUserProfile();
    this.correctPin = profile ? profile.get("pin") : null;
    this.bindPinToDisplay();

    // The keypad belongs to this component, so the lookups are scoped to it.
    // A document wide query takes the first match on the page, and the
    // listeners stay attached after the component is destroyed.
    this.onKeyDown = (e) => {
      if (!VueInstance.locked) return;
      const key = this.$el.querySelector(`[data-value="${e.key}"]`);
      if (key) key.click();
    };
    window.addEventListener("keydown", this.onKeyDown);
    this.listeners.push([window, "keydown", this.onKeyDown]);

    const backArrow = this.$el.querySelector(".keyboard--button__back-arrow");
    if (backArrow) {
      this.onBackArrow = () => {
        if (this.disableInput) return;
        this.pinArray.pop();
        this.bindPinToDisplay();
      };
      this.listen(backArrow, "click", this.onBackArrow);
    }

    const clearButton = this.$el.querySelector(".keyboard--button__x");
    if (clearButton) {
      this.onClear = () => {
        if (this.disableInput) return;
        this.pinArray = [];
        this.bindPinToDisplay();
      };
      this.listen(clearButton, "click", this.onClear);
    }

    this.initKeypad();

    if (!window.hasMountedHome) {
      this.pinArray = [];
      this.$root.$data.locked = true;
      this.disableInput = false;
    }
    this.bindPinToDisplay();
  },
  beforeDestroy() {
    this.listeners.forEach(([target, event, handler]) => {
      target.removeEventListener(event, handler);
    });
    this.listeners = [];
  },
  methods: {
    listen(target, event, handler) {
      target.addEventListener(event, handler);
      this.listeners.push([target, event, handler]);
    },
    async evaluatePin() {
      const enteredPin = String(this.pinArray.join(""));
      if (this.correctPin == null || this.correctPin == "") {
        const profile = await CCDb.getUserProfile();
        if (!profile) {
          this.pinArray = [];
          this.bindPinToDisplay("error");
          return;
        }
        profile.set("pin", enteredPin);
        await profile.save();
        this.openLock();
      } else if (enteredPin == this.correctPin || this.correctPin == "") {
        this.disableInput = true;
        setTimeout(() => {
          this.bindPinToDisplay("success");
          setTimeout(() => {
            this.openLock();
          }, 500);
        }, 250);
      } else {
        this.disableInput = true;
        setTimeout(() => {
          this.bindPinToDisplay("error");
          setTimeout(() => {
            this.pinArray = [];
            this.bindPinToDisplay();
            this.disableInput = false;
          }, 350);
        }, 250);
      }
    },
    initKeypad() {
      this.$el.querySelectorAll(".keypad--button[data-value]").forEach((el) => {
        this.listen(el, "click", (evt) => {
          if (this.disableInput) return;
          if (this.pinArray.length < 4) {
            this.pinArray.push(evt.currentTarget.getAttribute("data-value"));
            this.bindPinToDisplay();
            if (this.pinArray.length === 4) this.evaluatePin(this.pinArray);
          }
        });
      });
    },
    openLock() {
      setTimeout(() => {
        window.hasMountedHome = true;
        this.$root.locked = false;
        this.$root.$data.showNavbar = true;
        this.pinArray = [];
        this.bindPinToDisplay();
      }, 300);
    },
    loginWithBiometrics() {
      if (typeof webkit !== "undefined" && webkit.messageHandlers) {
        webkit.messageHandlers.callback.postMessage(`faceId|auth`);
        window.faceIdAuthenticated = (x) => {
          if (x == "success") VueInstance.$data.locked = false;
          else if (x == "failure") ModernModals.alert("Couldn't Verify Identity!");
          else if (x == "error")
            ModernModals.alert("You may not have any faces or fingerprints registered");
          else if (x == "notSupported")
            ModernModals.alert("Your device doesn't support biometric signin.");
        };
      } else {
        ModernModals.alert("Your device doesn't support biometric signin yet.");
      }
    },
    bindPinToDisplay(pinStatus = "") {
      this.$el.querySelectorAll(".pin-circle").forEach((el, index) => {
        if (pinStatus === "success") {
          el.addClass("success");
        } else if (pinStatus === "error") {
          el.addClass("error");
        } else if (index > this.pinArray.length - 1) {
          el.removeClass("entered");
          el.removeClass("success");
          el.removeClass("error");
        } else {
          el.addClass("entered");
        }
      });

      const dots = this.$el.querySelector(".confirmation-dots");
      if (!dots) return;
      if (pinStatus === "error") dots.addClass("error");
      else dots.removeClass("error");
    },
  },
};
</script>
